module.exports = __webpack_public_path__ + "static/media/docUpload.2619069d.svg";